import React from "react";
import homepage from "../images/homepage.png";
import "./Main.css";

const ArticleSection = () => {
  return (
    <div className="blogPage__article-section">
      <div className="blogPage__article-section-inner">
        <div className="blogPage__article-section-main">
          <p>
            Awa Digital built and maintains the ordering software for
            Jazzy&apos;s Burger: mobile apps, web ordering, payments, and an
            admin system used across multiple cities in Nigeria.
          </p>
          <p>
            We launched with JJB Food Concepts in December 2022. The product has
            since expanded beyond Lagos to additional branches.
          </p>
          <p>
            Customers can browse menus, customise orders, and pay through
            multiple gateways (card, bank transfer, USSD, and more). Orders are
            routed to the right branch. The admin system covers catalogue,
            pricing, fulfilment, and branch management.
          </p>
          <img className="screenshots" src={homepage} alt="Jazzy's Burger app homepage" />
          <p>
            Download the app from the{" "}
            <a
              href="https://jazzysburger.com/"
              target="_blank"
              rel="noreferrer"
            >
              Jazzy&apos;s Burger website
            </a>{" "}
            or search &quot;Jazzy&apos;s Burger&quot; on the App Store or Google
            Play.
          </p>
          <p className="jazzy-links">
            <a
              href="https://jazzysburger.com/"
              rel="noreferrer"
              target="_blank"
            >
              jazzysburger.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ArticleSection;
